import { css } from "emotion";
import { max } from "../../utils/CssUtils";

const P = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 768,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  maxWidth = "none",
  mobileMaxWidth = "none",
  semiBold = false,
  children
}) => {
  const style = css({
    fontSize: 16,
    fontWeight: semiBold ? 600 : 400,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    marginLeft: maxWidth === "auto" ? 0 : "auto",
    marginRight: maxWidth === "auto" ? 0 : "auto",
    [max(breakpoint)]: {
      fontSize: 14,
      marginTop: marginTopMobile,
      marginBottom: marginBottomMobile
    }
  });

  return <p className={css(style)}>{children}</p>;
};

export default P;
